import React from 'react';

const RefundPolicy = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 font-handwritten">Refund & Dispute Policy</h1>
      <div className="space-y-6 text-gray-700 dark:text-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Refund Eligibility</h3>
          <p className="mb-2">Refunds are available for items returned within 30 days of delivery that meet our return eligibility requirements. Please see our Return Policy for detailed information on eligible returns.</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Approved returns will be refunded to the original payment method</li>
            <li>Original shipping charges are non-refundable unless the return is due to our error</li>
            <li>Return shipping costs are the responsibility of the customer except for damaged or defective items</li>
          </ul>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Refund Processing Time</h3>
          <p className="mb-2">Once your return is received and inspected, we will process your refund within 5-7 business days. The time it takes for the refund to appear in your account depends on your payment method:</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Credit/Debit Cards: 5-10 business days</li>
            <li>PayPal: 3-5 business days</li>
            <li>Store Credit: Immediately available after processing</li>
          </ul>
          
          <p className="mt-2">You will receive an email notification when your refund has been processed.</p>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Partial Refunds</h3>
          <p className="mb-2">In some cases, partial refunds may be granted:</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Items returned with signs of use or wear</li>
            <li>Items returned without original packaging or missing components</li>
            <li>Items on sale or purchased with promotional discounts</li>
          </ul>
          
          <p className="mt-2">The condition of the returned item will be evaluated before a partial refund is issued.</p>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Dispute Resolution</h3>
          <p className="mb-2">If you are dissatisfied with your purchase or our service, we encourage you to contact our customer service team before initiating a payment dispute or chargeback. We are committed to resolving issues fairly and promptly.</p>
          
          <p className="mb-2">To resolve a dispute:</p>
          <ol className="list-decimal pl-5 space-y-1 mt-2">
            <li>Contact our customer service team at <a href="mailto:support@ryscircus.com" className="text-blue-600 dark:text-blue-400 hover:underline">support@ryscircus.com</a></li>
            <li>Provide your order number and a detailed description of the issue</li>
            <li>Include any relevant photos or documentation</li>
            <li>Allow us 48 hours to respond to your concern</li>
          </ol>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Payment Disputes and Chargebacks</h3>
          <p className="mb-2">If you believe an unauthorized charge has been made to your payment method, please contact us immediately. For disputes regarding authorized purchases, please attempt to resolve the issue with us directly before initiating a chargeback with your payment provider.</p>
          
          <p className="mb-2">In the event of a payment dispute or chargeback:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>We will cooperate fully with the investigation</li>
            <li>We will provide all relevant transaction information to the payment provider</li>
            <li>If a chargeback is filed, your account may be temporarily suspended until the dispute is resolved</li>
            <li>Fraudulent chargeback claims may result in account termination and additional legal action</li>
          </ul>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Information</h3>
          <p className="mb-2">For refund inquiries or dispute resolution, please contact our customer service team:</p>
          
          <ul className="list-none space-y-1 mt-2">
            <li>Email: <a href="mailto:support@ryscircus.com" className="text-blue-600 dark:text-blue-400 hover:underline">support@ryscircus.com</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
